export default __webpack_public_path__ + "static/media/02_SUMIKA.36d77420.png";